import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  standalone: true,
})
export class SidebarComponent {
  private auth = inject(AuthService);

  // Admin-only nav visibility; the /clients route is independently guarded.
  readonly isGlobalAdmin$ = this.auth.isGlobalAdmin$;

  logout(): void {
    this.auth.logout();
  }
}
